import { create } from 'zustand';

type State = {
  formData: Record<string, any> | null;
};

type Action = {
  setFormData: (val: State['formData']) => void;
  getFormData: () => State['formData'];
};

export const useFormDataStore = create<State & Action>()((set, get) => ({
  formData: null,
  getFormData: () => get().formData,
  setFormData: (formData: State['formData']) => set(() => ({ formData }), true),
}));
